import { render, staticRenderFns } from "./IdentificationNumber.vue?vue&type=template&id=4880b996&scoped=true&"
import script from "./IdentificationNumber.vue?vue&type=script&lang=js&"
export * from "./IdentificationNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4880b996",
  null
  
)

export default component.exports